import {deepClone} from "../../../../util/state/commonFunctions";
import dayjs from "dayjs";

const checkOutInSessionStrgName = "check-out-in";

const saveCheckOutInSessionStorage = (data: any) => {
    let checkEquipments = null;
    // del snapshots form equipments
    if (!!data?.checkEquipments?.equipments) {
        const equipments = data.checkEquipments.equipments
            .map((equip: any) => {
                const eq = deepClone(equip);
                eq.base64Init = '';
                eq.checkPhoto = '';
                eq.fileExt = '';
                return eq;
            });
        checkEquipments = deepClone(data.checkEquipments);
        checkEquipments.equipments = equipments;
    }

    const saveData = {
        type: data.type,
        step: data.step,
        raFetchedData: {
            idTenant:               data.raFetchedData.idTenant,
            idRentalAgreement:      data.raFetchedData.idRentalAgreement,
            raNumber:               data.raFetchedData.raNumber,
            renewalsSubstitution:   data.raFetchedData.renewalsSubstitution,
            raScanGenerationDate:   data.raFetchedData.raScanGenerationDate,
            hasUnconfirmedCustomerReports: data.raFetchedData.hasUnconfirmedCustomerReports,
            hasUnconfirmedCustomerReportsCheckIn: data.raFetchedData.hasUnconfirmedCustomerReportsCheckIn,
            vehicle: {
                plate:                  data.raFetchedData.vehicle.plate,
                vin:                    data.raFetchedData.vehicle.vin,
                carClassDescription:    data.raFetchedData.vehicle.carClassDescription,
                brandDescription:       data.raFetchedData.vehicle.brandDescription,
                modelDescription:       data.raFetchedData.vehicle.modelDescription,
                kilometersOnStart:      data.raFetchedData.vehicle.kilometersOnStart,
                currentTermicTankFilling: data.raFetchedData.vehicle.currentTermicTankFilling,
                currentElectricTankFilling: data.raFetchedData.vehicle.currentElectricTankFilling,
                enginePowerGroupCode:   data.raFetchedData.vehicle.enginePowerGroupCode,
            },
            raOwner: {
                firstName:  data.raFetchedData.raOwner.firstName,
                lastName:   data.raFetchedData.raOwner.lastName,
            },
            billingOwner: {
                customerId: data.raFetchedData.billingOwner.customerId,
            },
            bookingDetail: {
                expectedCheckInDate:    data.raFetchedData.bookingDetail.expectedCheckInDate,
                offerId:                data.raFetchedData.bookingDetail.offerId,
                pickupDate:             data.raFetchedData.bookingDetail.pickupDate,
                pickUpLocation:         data.raFetchedData.bookingDetail.pickUpLocation,
                dropOffLocation:        data.raFetchedData.bookingDetail.dropOffLocation,
                ancillaries:            data.raFetchedData.bookingDetail.ancillaries
            },
            financialInfo: {
                segment: data.raFetchedData.financialInfo.segment,
                creditType: data.raFetchedData.financialInfo.creditType
            },
            quotationInfo: {
                damageExcess:   data.raFetchedData.quotationInfo.damageExcess,
                reservedRateId: data.raFetchedData.quotationInfo.reservedRateId
            },
            checkOut: {
                kmsOnCheck:             data.raFetchedData.checkOut.kmsOnCheck,
                tankLevelOnCheck:       data.raFetchedData.checkOut.tankLevelOnCheck,
                batteryLevelOnCheck:    data.raFetchedData.checkOut.batteryLevelOnCheck,
                dmsIdentificationCode:  data.raFetchedData.checkOut.dmsIdentificationCode,
                expectedCheckoutDate:   data.raFetchedData.checkOut.expectedCheckoutDate,
                effectiveCheckoutDate:  data.raFetchedData.checkOut.effectiveCheckoutDate
            },
            checkIn: {
                expectedCheckInDate:    data.raFetchedData.checkIn.expectedCheckInDate,
                dmsIdentificationCode:  data.raFetchedData.checkIn.dmsIdentificationCode
            }
        },
        checkVehicleStatus: {
            kmsOnCheck: 				!!data?.checkVehicleStatus?.kmsOnCheck ? data.checkVehicleStatus.kmsOnCheck : '',
            tankLevelOnCheck: 			!!data?.checkVehicleStatus?.tankLevelOnCheck ? data.checkVehicleStatus.tankLevelOnCheck : null,
            batteryLevelOnCheck: 		!!data?.checkVehicleStatus?.batteryLevelOnCheck ? data.checkVehicleStatus.batteryLevelOnCheck : null,
            effectiveDateTime:          data?.checkVehicleStatus?.effectiveDateTime,
            minEffectiveDropOffDate:    data?.checkVehicleStatus?.minEffectiveDropOffDate,
            maxEffectiveDropOffDate:    data?.checkVehicleStatus?.maxEffectiveDropOffDate,
            now:						data?.checkVehicleStatus?.now,
            dropOffLocation:			data?.checkVehicleStatus?.dropOffLocation,
            nonRunningVehicle: 			data?.checkVehicleStatus?.nonRunningVehicle,
            raRetroDatableCheckIn: 		data?.checkVehicleStatus?.raRetroDatableCheckIn,
            keyBoxServiceApplicable: 	data?.checkVehicleStatus?.keyBoxServiceApplicable
        },
        existingDamage:                 data.existingDamage,
        checkDamage:                    data.checkDamage,
        events:                         data.events,
        equipmentsEvent:                data.equipmentsEvent,
        checkEquipments:                checkEquipments,
        bufferDataAction:               {
                                            damage: {
                                                action: null,
                                                data: null
                                            },
                                            event: {
                                                action: null,
                                                data: null
                                            },
                                            equipments: {
                                                action: null,
                                                previousCheckData: null
                                            }
                                        }
    }

    sessionStorage.setItem(checkOutInSessionStrgName, JSON.stringify(saveData));
}

const getCheckOutInSessionStorage = () => {
    const value = sessionStorage.getItem(checkOutInSessionStrgName);
    if (!!value) {
        let obj = JSON.parse(value);
        obj.checkVehicleStatus.effectiveDateTime = dayjs(obj.checkVehicleStatus.effectiveDateTime);
        return obj;
    } else {
        return null;
    }
}

const clearCheckOutInSessionStorage = () => {
    sessionStorage.removeItem(checkOutInSessionStrgName);
}

export {
    saveCheckOutInSessionStorage,
    getCheckOutInSessionStorage,
    clearCheckOutInSessionStorage
}
